import api from '../../services/api';
import i18n from '../../utils/i18n';
import { toast } from 'react-toastify';

export const fetchEntitiesCount = async () => {
  const response = await api.get(`/admin/entities-count`);

  if (!response) {
    toast.error(i18n.t('error.api.get-entities-count'));
  }

  return response.data;
};
